import React, {Fragment} from "react";
import {findPartCode} from "../../../../../core/utils/stepHelpers";

/**
 * PART_3D, MATERIAL 타입 렌더링
 */
export const renderPartStep = ({
  PartComponent,
  stepObject,
  langData,
  navigationDataObject,
  slideToSubHandler
                               }) => {
  if (stepObject.stepItems.length === 0) return null;


  return (
    <PartComponent
      title={stepObject[langData.langName]}
      code={findPartCode(stepObject.stepItems[0])}
      partArray={stepObject.stepItems}
      navigationDataObject={navigationDataObject}
      stepObject={stepObject}
      slideToSubHandler={slideToSubHandler}
    />
  );
};

/**
 * PART_2D (Personalization) 타입 렌더링
 */
export const renderPersonalStep = ({
  PartComponent,
  stepObject,
  langData,
  navigationDataObject,
  slideToSubHandler
}) => {
  return (
    <Fragment>
      {stepObject.stepItems.map((personalItemObject, idx) => {
        return (
          <PartComponent
            key={'PersonalStep_' + idx}
            title={personalItemObject.partPersonalization[langData.langName]}
            code={personalItemObject.partPersonalization.code}
            personalItemObject={personalItemObject}
            navigationDataObject={navigationDataObject}
            stepObject={stepObject}
            slideToSubHandler={slideToSubHandler}
          />
        );
      })}
    </Fragment>
  );
};
